module.exports = __webpack_public_path__ + "static/media/joker-punch.9434628f.png";